module.exports = __webpack_public_path__ + "static/media/icons-info.4761af7a.svg";